$(".home-tags").click(function(){
    $(".home-tags").removeClass("home-tags-active");
    $(this).addClass("home-tags-active");
    $(".post-feed").hide();
    let target = $(this).attr("data-target");
    $(target).show();
    return false;
});

(function() {
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches && localStorage.getItem('theme') == null) {
        document.documentElement.classList.add('dark-mode');
        localStorage.setItem("theme", "dark-mode");
        $("#dm-switch").prop("checked", true);
    }
    let cookie = localStorage.getItem("theme") || "";
    if(cookie){
        document.documentElement.classList.add(cookie);
        if(cookie === "dark-mode"){
            $("#dm-switch").prop("checked", true);
        }
    }

    const urlParams = new URLSearchParams(window.location.search);
	const mobile = urlParams.get('mobile');
    if(mobile == "true"){
    	$(".share-button").hide();
    }
})();

function themeToggle() {
    if($("#dm-switch").is(":checked")){
        document.documentElement.classList.add("dark-mode");
        localStorage.setItem("theme", "dark-mode");
    }else{
        document.documentElement.classList.remove("dark-mode");
        localStorage.setItem("theme", "light-mode");
    }
    
    // let theme = localStorage.getItem("theme");
    // if (theme && theme === "dark-mode") {
    //     localStorage.setItem("theme", "");
    //     // $("#dm-switch").prop("checked", false);
    // } else {
    //     localStorage.setItem("theme", "dark-mode");
    //     // $("#dm-switch").prop("checked", true);
    // }
}

$("#dm-switch").click(function(){
    themeToggle();
});

var ghostHunterSearch = $("#search-field").ghostHunter({
    results: "#results",
    item_preprocessor: function(item) {
        console.log("Item", item);
        return item;
    },
    onComplete: function(results) {
        console.log("On complete triggered", results);
        if($("#search-field").val() != ""){
            if(results.length === 0){
                $("#search-result-title").hide();
                $("#search-result-no-data").show();
            }else{
                $("#search-result-title").show();
                $("#search-result-no-data").hide();
            }
        }else{
            $("#search-result-title").hide();
            $("#search-result-no-data").hide();
        }
    },
    // result_template: "<a id='gh-{{ref}}' class='gh-search-item' href='{{link}}'>" + 
    // "<img src='{{feature_image}}' />" + 
    // "<p><h2>{{title}}</h2><h4>{{description}}</h4><h4>{{pubDate}}</h4></p></a>"
    result_template: 
        '<article id="gh-{{ref}}" class="post-card gh-search-item">' +
        '<a class="post-card-image-link" href="{{link}}">' +
            '<img class="post-card-image"' +
                'src="{{feature_image}}" ' +
            '/>' +
        '</a>' +

        '<div class="post-card-content">' +
            '<a class="post-card-content-link" href="{{link}}">' +
                '<header class="post-card-header">' +
                    '<h2 class="post-card-title">{{title}}</h2>' +
                    '<span class="post-card-time">{{pubDate}} <span class="bull">&bull;</span> {{reading_time}} min read</span>' +
                '</header>' +
            '</a>' +
        '</div>' +
    '</article>'
});

$("#search-clear").click(function(){
    //ghostHunterSearch.clear();
    $("#search-field").val("").focus();
    $("#search-result-title").hide();
    $("#search-result-no-data").hide();
});

// load Branch
(function(b,r,a,n,c,h,_,s,d,k){if(!b[n]||!b[n]._q){for(;s<_.length;)c(h,_[s++]);d=r.createElement(a);d.async=1;d.src="https://cdn.branch.io/branch-latest.min.js";k=r.getElementsByTagName(a)[0];k.parentNode.insertBefore(d,k);b[n]=h}})(window,document,"script","branch",function(b,r){b[r]=function(){b._q.push([r,arguments])}},{_q:[],_v:1},"addListener applyCode autoAppIndex banner closeBanner closeJourney creditHistory credits data deepview deepviewCta first getCode init link logout redeem referrals removeListener sendSMS setBranchViewData setIdentity track validateCode trackCommerceEvent logEvent disableTracking".split(" "), 0);
// init Branch
branch.init('key_live_ng7PmnTBSpQodSogzXknbhniwEoe1poi');